@if (data()) {
  <div class="flex w-full overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200">
      <thead>
        <tr>
          <th></th>
          <th
            class="vertical-text w-14 border bg-primary-30 px-6 py-4 text-center text-xs font-medium uppercase tracking-wider text-white">
            Nivel requerido
          </th>
          @if (employees().length > 0) {
            @for (employee of employees(); track employee) {
              <th
                class="vertical-text w-14 border bg-gray-50 px-6 py-4 text-center text-xs font-medium uppercase tracking-wider text-gray-500">
                {{ employee }}
              </th>
            }
          }
        </tr>
      </thead>
      <tbody class="border">
        @for (skillGroup of skillGroups(); track skillGroup) {
          <tr class="border">
            <td
              class="whitespace-nowrap border border-gray-200 bg-gray-50 px-6 py-4 font-bold">
              {{ skillGroup }}
            </td>
            <td
              class="whitespace-nowrap bg-primary-30 px-6 py-4 font-bold text-white">
              {{ requiredAvg(skillGroup) | number: '1.2-2' }}
            </td>
            @for (employee of employees(); track employee) {
              <td class="whitespace-nowrap px-6 py-4 font-bold">
                {{ scoreSkillGroupAvg(skillGroup, employee) | number: '1.2-2' }}
              </td>
            }
          </tr>
          @for (item of groupedData()[skillGroup]; track item.skillId) {
            <tr class="border">
              <td class="whitespace-nowrap px-6 py-4">{{ item.skill }}</td>
              <td class="whitespace-nowrap bg-primary-30 px-6 py-4 text-white">
                {{ item.requiredScore | number: '1.2-2' }}
              </td>
              @for (employee of employees(); track employee) {
                <td
                  class="whitespace-nowrap px-6 py-4"
                  [ngClass]="
                    getColorClass(
                      scoreSkill(skillGroup, item.skillId, employee)
                    )
                  ">
                  {{ scoreSkill(skillGroup, item.skillId, employee) }}
                </td>
              }
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
}
